export const QUESTION_LIST: { [key: string]: string }[] = [
  {
    key: 'rate_sponsorship_mentorship_opportunity',
    question: 'Opportunity for sponsorship and mentorship program?',
  },
  { key: 'rate_equal_treatment_of_men_and_women', question: 'Equal treatment of men and women?' },
  { key: 'rate_equal_pay_for_equal_performance', question: 'Equal pay for equal performance?' },
  {
    key: 'rate_equal_opportunities_to_move_up_organization',
    question: 'Equal opportunity to move up in the organization?',
  },
];
